import script from "./PaymentCompleteView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentCompleteView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentCompleteView.vue?vue&type=style&index=0&id=4bde8911&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bde8911"]])

export default __exports__